import { useIsPartOfANetwork } from '@weenat/client/dist/core/orgs'
import { useIntl } from '@weenat/wintl'
import Text from 'app/src/kit/Text'
import LoadingCircle from 'app/src/kit/loaders/LoadingCircle'
import HeaderActions from 'app/src/layouts/HeaderActions'
import NetworksList from 'app/src/networks/NetworksList'
import { useToken } from 'app/state'

function Networks() {
  const { t } = useIntl()
  const [token] = useToken()

  const {
    orgsRequest,
    isPartOfANetwork,
    canAccessANetworkOrg: hasSomeNetworkOrg,
    canAccessAnOrgInsideANetwork: hasSomeNetworkSubscribedOrg
  } = useIsPartOfANetwork(token)

  const shouldNotShowNetworksListText = hasSomeNetworkOrg
    ? t('models.network.actions.hiding_network_list_because_has_network')
    : hasSomeNetworkSubscribedOrg
      ? t('models.network.actions.hiding_network_list_because_has_network_subscribed_org')
      : null

  return (
    <>
      <HeaderActions />
      {orgsRequest.isLoading ? (
        <LoadingCircle />
      ) : isPartOfANetwork ? (
        <Box $px='lg'>
          <Text $fontSize='lg' $textAlign='center'>
            {shouldNotShowNetworksListText}
          </Text>
        </Box>
      ) : (
        <NetworksList />
      )}
    </>
  )
}

export const Component = Networks
export default Networks
